import { render } from "./list.vue?vue&type=template&id=5422046c&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=5422046c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5422046c"

export default script